import { z } from 'zod';

export interface Paginated<T> {
  data: T[];
  total: number;
  limit: number;
  offset: number;
}

export const SORT_ORDER = ['asc', 'desc'] as const;
export const SortOrderSchema = z.enum(SORT_ORDER);
export type SortOrder = z.infer<typeof SortOrderSchema>;

/** Canonical query contract for every sortable paginated endpoint. */
export const SortQuerySchema = z.object({
  sortBy: z.string().trim().min(1).max(64).optional(),
  sortOrder: SortOrderSchema.optional(),
});

export type SortQuery = z.infer<typeof SortQuerySchema>;
